module.exports = __webpack_public_path__ + "img/angle-arrow.3ae61860.svg";